'use client'

import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'

export function PopularItemsCheckbox({
  handleUpdatedSelectedItems,
  isSelected,
  item,
}: {
  handleUpdatedSelectedItems?: () => void
  isSelected: boolean
  item: { displayName: string; value: string }
}) {
  const checkboxClassName = classMerge(
    'size-6 appearance-none rounded border border-neutral400',
    isSelected
      ? 'bg-success700'
      : 'bg-white md:group-hover:border-primary300 md:group-hover:bg-primary300',
  )
  return (
    <div className='mt-3 flex flex-col gap-2.5' key={item.value}>
      <label
        className={`flex w-full cursor-pointer items-center gap-2 rounded-[6px] border border-neutral200 bg-white p-4`}
      >
        <div className='flex flex-col gap-2 md:flex-row'>
          <Text
            className='line-clamp-2'
            styleName='p-small'
            value={item.displayName}
          />
        </div>
        <div
          className={
            'relative ml-auto inline-block size-6 w-min cursor-pointer hover:bg-white'
          }
        >
          <input
            checked={isSelected}
            className={checkboxClassName}
            name={'selectedMedication'}
            onChange={handleUpdatedSelectedItems}
            type='checkbox'
            value={item.value}
          />
          {isSelected && (
            <Icon
              className='pointer-events-none absolute left-0 top-0 !box-border !size-6 p-[5px] text-sm text-white'
              icon={faCheck}
            />
          )}
        </div>
      </label>
    </div>
  )
}
